import { FileReader, FileWriter } from '@/platform'
import FileName from '../ComControl/FileName'
import WelfareGoods from './WelfareGoods'
import FontProperty from '../MallNewClass/FontProperty'
import PropertyViewPort from './PropertyViewPort'
import { WelfareType } from './WelfareModel'

class WelfareDetailModel {
    public ID: number = 0 // 福利ID
    public X: number = 0 // 福利X坐标
    public Y: number = 0 // 福利Y坐标
    public Opened: Boolean = false // 是否开启
    public Name: string = '' // 名称
    public NameFont: FontProperty = new FontProperty() // 商品名称文字属性
    public NameX: number = 0 // 商品名称的X坐标
    public NameY: number = 0 // 商品名称的Y坐标
    public Synopsis: string = '' // 简介
    public SynopsisFont: FontProperty = new FontProperty() // 简介文字属性
    public SynopsisX: number = 0 // 简介的X坐标
    public SynopsisY: number = 0 // 简介的Y坐标
    public DaysTipFont: FontProperty = new FontProperty() // 累签提示文字属性
    public DaysTipX: number = 0 // 累签提示的X坐标
    public DaysTipY: number = 0 // 累签提示的Y坐标
    public DaysCountFont: FontProperty = new FontProperty() // 累签天数文字属性
    public DaysCountX: number = 0 // 累签天数的X坐标
    public DaysCountY: number = 0 // 累签天数的Y坐标
    public ViewSignin: PropertyViewPort = new PropertyViewPort() // 签到图片坐标坐标
    public ViewReceived: PropertyViewPort = new PropertyViewPort() // 已领取图片坐标坐标
    public WindowShowImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_7区域底图.png' }) // 橱窗底板图
    public ViewWindowShow: PropertyViewPort = new PropertyViewPort() // 橱窗底板坐标坐标
    public ListWelfareGoods: WelfareGoods[] = []

    private FontName = ''

    constructor(FontName = '宋体') {
        this.FontName = FontName
        this.DaysCountFont = new FontProperty(this.FontName, 16, '94,88,76')
        this.DaysTipFont = new FontProperty(this.FontName, 12, '94,88,76')
        this.NameFont = new FontProperty(this.FontName, 22, '94,88,76')
        this.SynopsisFont = new FontProperty(this.FontName, 12, '255,255,255')

        this.DaysCountFont = new FontProperty('宋体', 16, '94,88,76')
        this.DaysTipFont = new FontProperty('宋体', 12, '94,88,76')
        this.NameFont = new FontProperty('宋体', 22, '94,88,76')
        this.SynopsisFont = new FontProperty('宋体', 12, '255,255,255')

        this.ViewReceived = new PropertyViewPort()
        this.ViewSignin = new PropertyViewPort()
        this.ViewWindowShow = new PropertyViewPort()
    }

    CreateGoods() {
        let lstWelfareGoods: WelfareGoods[] = []
        let count = 7

        if (this.ID === WelfareType.Charge) {
            count = 14
        }

        for (let i = 0; i < count; i++) {
            let welfareGoods = new WelfareGoods()
            welfareGoods.ID = i + 1

            welfareGoods.Name += welfareGoods.ID
            welfareGoods.ReceivingCondition = welfareGoods.ID
            lstWelfareGoods.push(welfareGoods)
        }

        this.ListWelfareGoods = lstWelfareGoods
        this.UpdateConditionDiscription()
    }

    public UpdateCondition(index: number) {
        let lastCondition = this.ListWelfareGoods[index].ReceivingCondition
        for (let i = index + 1; i < this.ListWelfareGoods.length; i++) {
            let welfareGoods = this.ListWelfareGoods[i]

            if (lastCondition >= welfareGoods.ReceivingCondition) {
                welfareGoods.ReceivingCondition = ++lastCondition
            }
        }
    }

    public UpdateConditionDiscription() {
        this.ListWelfareGoods.forEach(item => {
            switch (this.ID) {
                case WelfareType.Charge:
                    item.ReceivingConditionDiscription = `≥${item.ReceivingCondition}朵`
                    break

                case WelfareType.Accumulative:
                    item.ReceivingConditionDiscription = `累计${item.ReceivingCondition}天`
                    break

                case WelfareType.Week:
                    switch (item.ReceivingCondition) {
                        case 1:
                            item.ReceivingConditionDiscription = '周一'
                            break
                        case 2:
                            item.ReceivingConditionDiscription = '周二'
                            break

                        case 3:
                            item.ReceivingConditionDiscription = '周三'
                            break

                        case 4:
                            item.ReceivingConditionDiscription = '周四'
                            break

                        case 5:
                            item.ReceivingConditionDiscription = '周五'
                            break

                        case 6:
                            item.ReceivingConditionDiscription = '周六'
                            break
                        case 7:
                            item.ReceivingConditionDiscription = '周日'
                            break

                        default:
                            item.ReceivingConditionDiscription = '周一'
                            break
                    }
                    break

                case WelfareType.New:
                    item.ReceivingConditionDiscription = `签到${item.ReceivingCondition}天`
                    break
                default:
                    break
            }
        })
    }

    readVersionedOui(reader: FileReader): void {
        this.ID = reader.readInt()
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Opened = reader.readInt() === 1 ? true : false
        this.Name = reader.readString()
        this.NameFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.NameX = reader.readInt()
        this.NameY = reader.readInt()
        this.Synopsis = reader.readString()
        this.SynopsisFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.SynopsisX = reader.readInt()
        this.SynopsisY = reader.readInt()
        this.DaysTipFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.DaysTipX = reader.readInt()
        this.DaysTipY = reader.readInt()
        this.DaysCountFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.DaysCountX = reader.readInt()
        this.DaysCountY = reader.readInt()
        this.ViewSignin.readVersionedOui(reader.readObj(reader.readInt()))
        this.ViewReceived.readVersionedOui(reader.readObj(reader.readInt()))
        this.WindowShowImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.ViewWindowShow.readVersionedOui(reader.readObj(reader.readInt()))

        const goodsLen = reader.readInt()
        for (let i = 0; i < goodsLen; i++) {
            const goods = new WelfareGoods()
            goods.readVersionedOui(reader.readObj(reader.readInt()))
            this.ListWelfareGoods.push(goods)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.ID)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeInt(this.Opened ? 1 : 0)
        writer.writeString(this.Name)
        this.NameFont.writeVersionedOui(writer)
        writer.writeInt(this.NameX)
        writer.writeInt(this.NameY)
        writer.writeString(this.Synopsis)
        this.SynopsisFont.writeVersionedOui(writer)
        writer.writeInt(this.SynopsisX)
        writer.writeInt(this.SynopsisY)
        this.DaysTipFont.writeVersionedOui(writer)
        writer.writeInt(this.DaysTipX)
        writer.writeInt(this.DaysTipY)
        this.DaysCountFont.writeVersionedOui(writer)
        writer.writeInt(this.DaysCountX)
        writer.writeInt(this.DaysCountY)
        this.ViewSignin.writeVersionedOui(writer)
        this.ViewReceived.writeVersionedOui(writer)
        this.WindowShowImage.writeVersionedOui(writer)
        this.ViewWindowShow.writeVersionedOui(writer)

        writer.writeInt(this.ListWelfareGoods.length)
        for (let i = 0; i < this.ListWelfareGoods.length; i++) {
            const goods = this.ListWelfareGoods[i]
            goods.writeVersionedOui(writer)
        }

        writer.writerLength()
    }
}

export default WelfareDetailModel
